import styled from 'styled-components/macro';

const Result = styled.span`
  color: hsl(0, 0%, 100%);
  font-size: 6rem;
  font-weight: bold;
  margin-bottom: 2rem;
`;

export default Result;
